import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ChartHeader from './chartHeader/ChartHeader';
import { colors } from '../../../../../../colorVars';
import { RefactoredChartContainer } from './chartContainer/RefactoredChartContainer';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';
import { observer } from 'mobx-react-lite';

export const ChartWrapper = observer(({ initialValues }) => {
  const { tradePlanStore } = useWebsocketStore();

  const [symbol, setSymbol] = useState(initialValues?.symbol || 'SPY');
  const [dataSource, setDataSource] = useState(
    initialValues?.dataSource || 'LIVE'
  );
  const [brokerage, setBrokerage] = useState(
    initialValues?.brokerage || 'TRADIER'
  );
  const [numberOfCandles, setNumberOfCandles] = useState(
    initialValues?.numberOfCandles || 20
  );
  const [timeUnit, setTimeUnit] = useState(initialValues.timeUnit || 'MINUTES');
  const [candleDuration, setCandleDuration] = useState(
    initialValues?.candleDuration || 1
  );
  const tradePlanId = initialValues?.tradePlanId ?? 'none';
  const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
  const startHour = tradePlan?.startHour ?? 9;
  const startMin = tradePlan?.startMin ?? 30;
  const [showCandleNumbers, setShowCandleNumbers] = useState(true);

  const setters = {
    setShowCandleNumbers,
    setSymbol,
    setDataSource,
    setBrokerage,
    setNumberOfCandles,
    setTimeUnit,
    setCandleDuration,
  };

  return (
    <div
      style={{
        backgroundColor: colors.grey,
        width: 'fit-content',
      }}
    >
      <ChartHeader
        type={initialValues.type}
        setters={setters}
        symbol={symbol}
        showCandleNumbers={showCandleNumbers}
        dataSource={dataSource}
        brokerage={brokerage}
        numberOfCandles={numberOfCandles}
        timeUnit={timeUnit}
        candleDuration={candleDuration}
      />

      <RefactoredChartContainer
        tradePlanId={tradePlanId}
        symbol={symbol}
        dataSource={dataSource}
        brokerage={brokerage}
        numberOfCandles={numberOfCandles}
        timeUnit={timeUnit}
        candleDuration={candleDuration}
        id={1}
        size={initialValues.size}
        margin={4}
        padding={30}
        showCandleNumbers={showCandleNumbers}
        startHour={startHour}
        startMin={startMin}
        setNumberOfCandles={setNumberOfCandles}
      />
    </div>
  );
});

ChartWrapper.propTypes = {
  initialValues: PropTypes.shape({
    brokerage: PropTypes.string,
    candleDuration: PropTypes.number,
    dataSource: PropTypes.string,
    numberOfCandles: PropTypes.number,
    symbol: PropTypes.string,
    timeUnit: PropTypes.string,
    tradePlanId: PropTypes.any,
    size: PropTypes.number,
    type: PropTypes.string,
  }),
};
